import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["fieldId", "isRequired"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import SmartUserPicker from '@atlaskit/smart-user-picker';
import { CreateField } from '../../../controllers/create-field';
export var TEST_ID = 'link-create-user-picker';
var DEFAULT_DEBOUNCE_TIME = 400;
var UserPickerWidth = '100%';

/**
 * A user picker utilising the SmartUserPicker.
 */

export function UserPicker(_ref) {
  var productKey = _ref.productKey,
    siteId = _ref.siteId,
    name = _ref.name,
    label = _ref.label,
    placeholder = _ref.placeholder,
    validators = _ref.validators,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? TEST_ID : _ref$testId,
    defaultValue = _ref.defaultValue;
  return jsx(CreateField, {
    name: name,
    label: label,
    isRequired: true,
    testId: testId,
    validators: validators
  }, function (_ref2) {
    var fieldId = _ref2.fieldId,
      isRequired = _ref2.isRequired,
      fieldProps = _objectWithoutProperties(_ref2, _excluded);
    return jsx(SmartUserPicker, {
      defaultValue: defaultValue ? _objectSpread(_objectSpread({}, defaultValue), {}, {
        type: 'user'
      }) : undefined,
      placeholder: placeholder,
      onChange: function onChange(value) {
        return fieldProps.onChange(value);
      },
      subtle: true,
      isMulti: false,
      productKey: productKey,
      siteId: siteId,
      fieldId: fieldId,
      inputId: fieldId,
      debounceTime: DEFAULT_DEBOUNCE_TIME,
      prefetch: true,
      isClearable: false,
      width: UserPickerWidth,
      required: isRequired
    });
  });
}